// extracted by mini-css-extract-plugin
export default {"Mackerel":"#D2D6D9","White":"#FFFFFF","BlueBase":"#615CFF","ScreenMLMin":"(min-width: 1025px)","SpacingXXS":"5px","fixedMobileCTAContainer":"G93e64a"};